/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RoutingService } from 'src/app/service/routing.service';
import { NewsService } from 'src/app/shared/services/data-api/news.service';
import { StoriesService } from 'src/app/shared/services/data-api/stories.service';

/**
 * Host for the embeddable reader widgets: the news reader (/widget/reader) and the
 * story reader (/widget/story).
 */
@Component({
  selector: 'app-widget-iframe',
  templateUrl: './widget-iframe.component.html',
  styleUrls: ['./widget-iframe.component.scss'],
})
export class WidgetIframeComponent implements OnInit, OnDestroy {
  /**
   * query parameters url
   */
  params: any;

  previousValue: any;

  /**
   * article for the news reader
   */
  article: any;

  /**
   * data for the story reader
   */
  newsfeedStory: any;

  match: any;

  tag: any;

  /**
   * quick fix for now to style the chat iframe
   */
  topLocationIsChat: boolean;

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public routing: RoutingService,
    private newsService: NewsService,
    private storiesService: StoriesService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.params = params;
        this.topLocationIsChat =
          window.top.location.pathname.split('/')[2] === 'chat';

        if (this.routing.isReader() && params.news) {
          if (params.type && params.id) {
            this.match = params.type + ':' + params.id;
          }
          if (params.tag) {
            this.tag = params.tag;
          }
          this.loadArticle(params.news, params);
        } else if (
          this.routing.isStoryReader() &&
          params.story &&
          this.routing.reFresh(params, this.previousValue, ['story'])
        ) {
          this.loadStory(params);
        }
        this.previousValue = params;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Reader: fetch the article, widening the time window on each failure before giving up.
   * A `redirectURL` short-circuits to the external fallback on the first error.
   */
  private loadArticle(news: string, params: any): void {
    const times = [params.time, params.time || 365, params.time || 1095];
    const attempt = (i: number) => {
      const p =
        i === 0 ? params : Object.assign({}, params, { time: times[i] });
      this.newsService.getNewsItem(news, p).subscribe({
        next: (result) => {
          this.article = result;
        },
        error: () => {
          if (params.redirectURL) {
            window.location.href = decodeURIComponent(params.redirectURL);
          } else if (i + 1 < times.length) {
            attempt(i + 1);
          } else {
            this.router.navigate(['/message/autherror']);
          }
        },
      });
    };
    attempt(0);
  }

  private loadStory(params: any): void {
    if (params.newstype !== 'Stories') {
      this.router.navigate([], {
        queryParams: { newstype: 'Stories' },
        queryParamsHandling: 'merge',
      });
      return;
    }
    this.storiesService
      .getStoryById(params.story, {
        customParams: { min_size: 1, size: 100 },
        body: {},
      })
      .subscribe({
        next: (result) => {
          this.newsfeedStory = result;
        },
        error: () => {
          if (params.redirectURL) {
            window.location.href = decodeURIComponent(params.redirectURL);
          } else {
            this.router.navigate(['/message/autherror']);
          }
        },
      });
  }
}
